import React, { useEffect, useImperativeHandle, KeyboardEvent } from "react";
import PropTypes from "prop-types";
import { Input, Button, Icon } from "semantic-ui-react";
import { formatToBEDatetime } from "../../utils";
import moment from "moment";
import TimePicker from "react-time-picker";

const TimeFreeTextBox24 = React.forwardRef((props: any, ref) => {

  const [time, setTime] = React.useState("00:00");

  const timeRef = React.useRef<any>()
  useEffect(() => {
    setTime(props.value);
  }, [props.value]);

  useImperativeHandle(ref, () => ({
    getTime: () => {
      return time;
    }
  }));


  useEffect(() => {
    if (timeRef.current) {
      const className = ".react-time-picker__inputGroup__"
      const { wrapper } = timeRef.current
      const minElm = wrapper.querySelector(`${className}minute`)
      const hourElm = wrapper.querySelector(`${className}hour`)

      if (props.checkTimeOverflow) {
        minElm.onkeypress = (e: KeyboardEvent<HTMLInputElement>) => {
          if (e.currentTarget.value?.length === 1 && +e.currentTarget.value >= 6) {
            e.preventDefault()
          }
        }
      }

      hourElm.onchange = function (e: KeyboardEvent<HTMLInputElement>) {
        let max = 23
        if (props.use12Hours) {
          max = 12
        }
        if ((props.use12Hours || props.checkTimeOverflow) && +e.currentTarget.value > max) {
          const time = `${max}:${minElm.value}`
          setTime(time);
          props.onChange(time);
        }
      }
    }

  }, [timeRef.current])


  const timeChange = (value: any) => {
    setTime(value);
    props.onChange(value);
  };

  const setCurrentTime = () => {
    if (props.disableIconClick) {
      return
    }
    if (!props.disabledClick) {
      let dateTime = formatToBEDatetime({ date: moment() });
      let time = dateTime.split(" ")[1];
      console.log("time1", time);
      setTime(time);
      props.onChange(time);
    } else {
      if (!time) {
        let dateTime = formatToBEDatetime({ date: moment() });
        let time = dateTime.split(" ")[1];
        setTime(time);
        props.onChange(time);
      }
    }
  };

  return (
    <div
      style={props.style ? props.style : {
        display: "flex",
        alignItems: "center",
      }}
    >
      <TimePicker
        // @ts-ignore
        ref={timeRef}
        style={{ border: "0px" }}
        className={props.className}
        onChange={timeChange}
        value={time}
        locale="sv-sv"
        clearIcon={null}
        format={"HH:mm"}
        disableClock
        autoFocus={props.autoFocus}
        onClick={props.onClick}
        disabled={props.disabled}
      />

      <div onClick={setCurrentTime} style={{ paddingLeft: "4px", margin: "auto" }}>
        <Icon name="clock" color="grey" disabled={props.disabled} />
      </div>
    </div>
  );
});

TimeFreeTextBox24.defaultProps = {
  disabled: false,
  onChange: () => { },
  value: "",
  className: "",
  disabledClick: false,
  onClick: () => { },
  autoFocus: true,
  disableIconClick: false,
  checkTimeOverflow: false,
  use12Hours: false
};

TimeFreeTextBox24.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
  disabledClick: PropTypes.bool,
  autoFocus: PropTypes.bool,
  disableIconClick: PropTypes.bool,
  checkTimeOverflow: PropTypes.bool,
  use12Hours: PropTypes.bool
};

export default React.memo(TimeFreeTextBox24);

/**
 *
 *
 * <Input
      disabled={props.disabled ? true : false}
      type='time'
      name="time"
      value={time}
      onChange={timeChange}
      icon='clock'
      className={props.className}
      onClick={setCurrentTime }
    />
 *
 */
